import ajax from "./request.js";
import store from "@/store";

let bool = process.env.NODE_ENV === "production";
const href = bool
  ? `https://${window.location.host}/api/cloud/instruction`
  : "/api/cloud/instruction";

function queryDirectivesList(data) {
  return ajax(`${href}/list`, {
    method: "POST",
    data,
  });
}

function deleteDirective(data) {
  return ajax(`${href}/deleteByIds`, {
    method: "POST",
    data,
  });
}
function getDirectiveInfo(data) {
  return ajax(`${href}/findById`, {
    method: "POST",
    data,
  });
}
function addOrUpdateDirective(data) {
  return ajax(`${href}/addOrUpdate`, {
    method: "POST",
    data,
  });
}
function upgradeInstruction(data) {
  return ajax(`${href}/upgradeInstruction`, {
    method: "POST",
    data,
  });
}

function downloadBlob(path, data, defaultFilename) {
  const token =
    (store.state &&
      store.state.loginAccountInfo &&
      store.state.loginAccountInfo.token) ||
    "";
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.open("POST", `${href}${path}`);
    xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    if (token) {
      xhr.setRequestHeader("token", token);
    }
    xhr.onload = function () {
      const blob = xhr.response;
      const type = (blob && blob.type) || "";
      if (type.indexOf("application/json") > -1) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            resolve(JSON.parse(reader.result));
          } catch (e) {
            reject(e);
          }
        };
        reader.readAsText(blob);
        return;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        let filename = defaultFilename;
        const dispo = xhr.getResponseHeader("Content-Disposition") || "";
        const m =
          dispo.match(/filename\*?=(?:UTF-8'')?([^;]+)/i) ||
          dispo.match(/filename=([^;]+)/i);
        if (m && m[1]) {
          filename = decodeURIComponent(m[1].replace(/"/g, "").trim());
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        resolve({ status: "success" });
        return;
      }
      reject(new Error("下载失败"));
    };
    xhr.onerror = () => reject(new Error("下载失败"));
    xhr.send(JSON.stringify(data || {}));
  });
}

function downloadInstructionTemplate() {
  return downloadBlob("/downloadTemplate", {}, "私有指令导入模板.xlsx");
}

function exportInstructions(data) {
  return downloadBlob("/export", data || {}, "私有指令.xlsx");
}

function importInstructions(file, typeId) {
  const token =
    (store.state &&
      store.state.loginAccountInfo &&
      store.state.loginAccountInfo.token) ||
    "";
  const form = new FormData();
  form.append("file", file);
  form.append("typeId", typeId);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${href}/import`);
    if (token) {
      xhr.setRequestHeader("token", token);
    }
    xhr.onload = function () {
      try {
        resolve(JSON.parse(xhr.responseText || "{}"));
      } catch (e) {
        reject(e);
      }
    };
    xhr.onerror = () => reject(new Error("导入失败"));
    xhr.send(form);
  });
}

export default {
  queryDirectivesList,
  deleteDirective,
  addOrUpdateDirective,
  getDirectiveInfo,
  upgradeInstruction,
  downloadInstructionTemplate,
  exportInstructions,
  importInstructions,
};
